<app-header></app-header>
<app-sidebar></app-sidebar>
<ngx-spinner bdColor="rgba(255,255,255,0.8)" size="large" color="#0058ff" type="ball-scale-pulse" [fullScreen]="true">
    <p style="color: black"> กำลังโหลดข้อมูล... </p>
</ngx-spinner>
<div class="content-wrapper" style="min-height: 307px">
    <div class="card">
        <div class="card-header bg-dark">
            <div style="float: left;">
            <h2>ฐานข้อมูลชาวไร่อ้อยบุรีรัมย์ และเลขบัญชี ธ.กรุงเทพ</h2>
            </div>
            <div style="float: right;">
                <div class="input-group mb-3" [formGroup]="Formfmdata">
                    <select class="form-select" formControlName="selectzone" (change)="Loadbyzone();">
                        <option value="00" selected>กรุณาเลือกโซน</option>
                        <option *ngFor="let item of zonecode" [ngValue]="item.SUPZONE">{{item.SUPZONE}}</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="card-body">
            <table class="table table-sm" #fmtable>
                <thead class="table table-dark">
                    <tr>
                        <th scope="col">เลขบัญชี</th>
                        <th scope="col">ชื่อ - นามสกุล</th>
                        <th scope="col">โควตาใหม่</th>
                        <th scope="col">เลขบัญชี ธ.กรุงเทพ </th>
                        <th scope="col">เบอร์โทรติดต่อ</th>
                        <th scope="col">นสส. ที่ดูแล</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of databyzone">
                        <td>{{item.FMCODE}}</td>
                        <td>{{item.fmname}}</td>
                        <td> <label *ngIf="item.QuotaID !== '0' ">{{item.QuotaID}}</label> 
                            <button *ngIf="item.QuotaID === '0'" (click)="Oneselect(item.FMCODE)" 
                            class="btn btn-dark btn-sm"  data-toggle="modal" data-target="#newbanknumber">
                                <i class="fas fa-user-plus"></i>
                            </button>
                        </td>
                        <td>{{item.BANKBBL}}</td>
                        <td>{{item.TEL}}</td>
                        <td>{{item.SUPCODE}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="newbanknumber" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header bg-dark">
                    <i class="fas fa-user-plus"></i> เลขโควตาใหม่สำหรับเปิดบัญชี ธ.กรุงเทพ 
                 <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                </div>
                <div class="modal-body" [formGroup]="Formfmdata">
                    <div class="input-group mb-3">
                        <span class="input-group-text"><i class="fas fa-user-tag"></i>&nbsp; ชื่อชาวไร่</span>
                        <input type="text" class="form-control" disabled formControlName="fmname">
                    </div>
                    <!-- <div class="input-group mb-3">
                        <span class="input-group-text"><i class="fas fa-search-dollar"></i>&nbsp; เลขโควตาใหม่</span>
                        <input type="text" class="form-control" disabled formControlName="fmcode">
                    </div> -->
                    <div class="input-group mb-3" *ngFor="let item of choseone">
                        <button type="button" class="btn btn-outline-secondary" data-dismiss="modal" 
                        (click)="Addnewcode(item.FMCODE_,item.SUPZONE);">บันทึก 
                            ยืนยันการขอเลขโควตาใหม่ 
                        </button>
                    </div>
                   
                </div>
                <div class="modal-footer" >
                   
                    <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
    <!-- Modal -->
</div>
<app-footer></app-footer>